export enum SignaturePatternEnum {
  DEFAULT = "default",
  SIGN_LEVEL_2_EC = "signlevel2ec",
  SIGN_LEVEL_QCP_EC = "signlevelQCPec",
  SEAL = "seal",
  SIGN_WITHOUT_LOGO = "signwithoutlogo",
  SEAL_WITHOUT_LOGO = "sealwithoutlogo",
}
